import React from "react";
import { Table, Button, Space, Popconfirm, Tag, Card, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const DrinkTable = ({ data, loading, onEdit, onDelete, cat }) => {

  // CATEGORY MAP
  const categoryMap = {};
  cat.forEach((item) => {
    categoryMap[item.id] = item.name.trim();
  });

  // MAIN TABLE
  const columns = [
    {
      title: "Drinks Name",
      dataIndex: "name",
    },
    {
      title: "Category",
      dataIndex: "category_id",
      render: (category_id) => categoryMap[category_id] || "-",
    },
    { title: "Volume", dataIndex: "qty" },
    { title: "Unit", dataIndex: "unit" },
    {
  title: (
    <Space>
      Sell Price

      <Tooltip title="Non AC Price ">
        <InfoCircleOutlined
          style={{
            color: "#1890ff",
            fontSize: "14px",
            cursor: "pointer",
          }}
        />
      </Tooltip>
    </Space>
  ),
  dataIndex: "sell_price",
},
    { title: "Original Price", dataIndex: "margin_price" },
    { title: "AC Price", dataIndex: "ac_price" },
    { title: "CGST", dataIndex: "cgst" },
    { title: "SGST", dataIndex: "sgst" },
    //{ title: "Tax", dataIndex: "tax" },
    { title: "HSN Code", dataIndex: "hsn_code" },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>
          {status}
        </Tag>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => onEdit(record)}>
            Edit
          </Button>

          <Popconfirm
            title="Delete drink?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button danger type="link">
               Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // PEG SUB TABLE
  const pegColumns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Qty",
      render: (_, peg, index, record) => (
        <span>
          {peg.qty}
        </span>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      render: (val) => <b>₹ {val}</b>,
    },
    {
      title: "AC Price",
      dataIndex: "ac_price",
      render: (val) => <b>₹ {val}</b>,
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}

      // EXPANDABLE PEG TABLE
      expandable={{
        expandedRowRender: (record) => (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "10px 0",
            }}
          >
            <Card
              style={{
                width: "60%",
                minWidth: 320,
                background: "#fff",
                borderRadius: 10,
                boxShadow:
                  "0 4px 10px rgba(0,0,0,0.08)",
              }}
              title="Peg List"
              size="small"
            >
              <Table
                dataSource={record.pegs || []}
                rowKey={(r, i) => i}
                pagination={false}
                size="small"
                columns={pegColumns}
              />
            </Card>
          </div>
        ),

        // only show expand icon if pegs exist
        rowExpandable: (record) =>
          record.pegs && record.pegs.length > 0,
      }}
    />
  );
};

export default DrinkTable;
